import ActionType from 'constants/actions';
import APP from 'app';


const initialState = {
    fetching: false,
    error: null,
    success: null,
    userInfo: JSON.parse(localStorage.getItem('user')) || {},
    isLoggedIn: APP.Utils.getJwtToken(),
    userMenu: [],
    mailStatus: false,
    showNotificationStrip: true
},
    userReducer = (state = initialState, action) => {
        const { payload, type } = action;
        try {
            switch (type) {
                case ActionType.USER.USER_JWT_UPDATED: {
                    const updatedUserInfo = APP.Utils.getUserInfoFromJwt(),
                        jwtToken = APP.Utils.getJwtToken();
                    return {
                        ...state,
                        userInfo: { userInfo: { ...updatedUserInfo, accessToken: jwtToken } }
                    };
                }
                case ActionType.USER.GET_USERINFO_FROM_JWT: {
                    const updatedUserInfo = payload;
                    return {
                        ...state,
                        userInfo: { ...updatedUserInfo }
                    };
                }
                case ActionType.USER.USER_LOGGED_IN: {
                    return {
                        ...state,
                        isLoggedIn: true
                    };
                }
                case ActionType.USER.USER_NOT_LOGGED_IN: {
                    return {
                        ...state,
                        isLoggedIn: false
                    };
                }
                case ActionType.MAILINATOR.EMAIL_STATUS: {
                    const { payload: resultRes = {}, showNotificationStrip } = payload,
                        { accepted = [] } = resultRes;
                    return {
                        ...state,
                        mailStatus: accepted.length > 0,
                        showNotificationStrip
                    };
                }
                case ActionType.THANKYOU.EMPTY_EMAILSTATUS: {
                    return {
                        ...state,
                        mailStatus: payload,
                        showNotificationStrip: true
                    };
                }
                default:
                    return state;
            }
        } catch (error) {
            return state;
        }
    };
export default userReducer;
